import pushEventToAdobeAnalytics from '../../../../../adobeAnalytics/adobe.utils';

export const sendClickEvent = (payload) => {
  const { name, buttonName, pos, type, dept } = payload;

  const pathname = window?.location?.pathname;
  const pathArr = pathname?.split('--') || [];
  const pjplannerClickValueArr = ['bundle'];

  if (pathArr.length === 2) {
    pjplannerClickValueArr.push(`${pathArr[1]}`);
  }
  if (pos) {
    pjplannerClickValueArr.push(pos);
  }
  if (type) {
    pjplannerClickValueArr.push(type);
  }
  if (dept) {
    pjplannerClickValueArr.push(dept);
  }
  pjplannerClickValueArr.push(name);
  const pjplannerClickValue = pjplannerClickValueArr.join('-');

  pushEventToAdobeAnalytics('pjplanner_interaction_click', {
    buttonName: buttonName?.toLowerCase(),
    pjplannerClickValue,
  });
};

const getAnalyticsFormatedBundleProducts = (products) => {
  if (products.length > 0) {
    return products.map((productObj, index) => {
      const {
        products: {
          unbxdProdId,
          productId,
          name,
          listPrice,
          offerPrice,
          lowOfferPrice,
          categoryId,
          primaryBrand,
        },
      } = productObj;
      return {
        id: productId || unbxdProdId,
        colorId: unbxdProdId || productId,
        name,
        price: offerPrice,
        listPrice,
        extPrice: lowOfferPrice,
        position: index + 1,
        type: 'bundle',
        pricingState: offerPrice < listPrice ? 'on sale' : 'full price',
        category: categoryId,
        dimension80: categoryId,
        dimension35: primaryBrand,
      };
    });
  }
  return [];
};

export const sendPageViewEvent = (payload) => {
  const { products, User, APIConfig, session } = payload;
  const productsFormattedEE = getAnalyticsFormatedBundleProducts(products);

  const pageDataAdobe = {
    pageName: 'bundle product',
    pageSection: 'bundle',
    pageSubSection: '',
    pageSubSection2: '',
    pageType: 'bundle product page',
  };

  pushEventToAdobeAnalytics('page_view', { pageData: pageDataAdobe, User, APIConfig, session });

  pushEventToAdobeAnalytics('product_impression', {
    productImpressions: productsFormattedEE,
    pageView: { pageData: pageDataAdobe, User, APIConfig, session },
  });
};
